export default __webpack_public_path__ + "static/SamsungOne-300-e8af78a691086a3ae5a172fb357e7797.ttf";